import { render, staticRenderFns } from "./InformationPanel.vue?vue&type=template&id=06ea99f4&scoped=true&"
import script from "./InformationPanel.vue?vue&type=script&lang=ts&"
export * from "./InformationPanel.vue?vue&type=script&lang=ts&"
import style0 from "./InformationPanel.vue?vue&type=style&index=0&id=06ea99f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ea99f4",
  null
  
)

export default component.exports